import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import './SiteFooter.css';

interface SiteFooterProps {
  minimal?: boolean;
  showLogo?: boolean;
}

const SiteFooter: React.FC<SiteFooterProps> = ({ minimal = false, showLogo = true }) => {
  return (
    <footer className={`site-footer ${minimal ? 'site-footer--minimal' : ''}`} data-tour="site-footer">
      <div className="container site-footer__content">
        <div className="site-footer__brand">
          {showLogo && (
            <Link to="/" className="site-footer__logo-link" aria-label="iKompete home">
              <BrandLogo reversed />
            </Link>
          )}
          <p>
            <a href="https://dsrs.illinois.edu" target="_blank" rel="noopener noreferrer">
              Data Science Research Services
            </a>
          </p>
        </div>

        <div className="site-footer__links" aria-label="Footer links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <a href="mailto:dsrs@business.illinois.edu">Support</a>
        </div>
      </div>

      <div className="container site-footer__bottom">
        <p>&copy; 2026 University of Illinois Urbana-Champaign. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default SiteFooter;

